import { useQuery } from '@tanstack/react-query';
import type { Audit } from '@seo/types';
import { apiGet } from '@/lib/api';
import { isTerminal } from '@/lib/queryClient';

/** Polls every 5s while status is non-terminal (blueprint §16.4). */
export function useAudit(id: string | undefined) {
  return useQuery({
    queryKey: ['audit', id],
    queryFn: () => apiGet<Audit>(`/v1/audits/${id}`),
    enabled: !!id,
    refetchInterval: (q) => (isTerminal(q.state.data?.status) ? false : 5_000),
  });
}
